import React, {useEffect} from "react";
import InputWrap from "../../InputWrap";
import {Form, Input} from "antd";

import {SensorNamesArray} from "../../../store/branches/sensors/stateTypes";

import classes from "../EditSensorsNames.module.scss";

interface SensorFormProps {
    sensorGroup?: SensorNamesArray
    form?: any
    isRefresh: boolean
    device_subtype?: string
}

const SensorForm: React.FC<SensorFormProps> = ({
                                                   sensorGroup,
                                                   form,
                                                   isRefresh,
                                                    device_subtype
                                               }) => {

    useEffect(() => {
        form.resetFields()
        form.setFieldsValue(sensorGroup);
    }, [sensorGroup, form, isRefresh]);

    return (
        <React.Fragment>
            {
                device_subtype === "Roll Stand" ? (

                <div className={classes.driver}>
                    <Form.Item name={sensorGroup?.id} initialValue={sensorGroup?.name}>
                        <Input maxLength={60}/>
                    </Form.Item>
                    <div className={classes.cssBaseLine}/>
                </div>
                ) : (

                    <div className={classes.driver}>
                        <span>{sensorGroup?.name}</span>
                        <div className={classes.cssBaseLine}/>
                    </div>
                )
                }


            <div className={classes.blocksWrap}>
                {
                    sensorGroup?.sensors?.map((item, index) => (

                        <InputWrap title={item?.label}
                                   classNameTitle={classes.inputWrapTitle}
                                   key={`input_sensor_name${item.id}${item.name}${item.label}${index}`}
                        >
                            <Form.Item name={item?.id} initialValue={item?.name}>
                                <Input maxLength={60}/>
                            </Form.Item>
                        </InputWrap>

                    ))
                }
            </div>
        </React.Fragment>
    );
};
export default SensorForm;
